/*
import { saveAs } from 'file-saver';
import store from '../atoms';
import { openInfoModalAtom } from '../atoms/modalAtoms';
import tStatic from '../translations';
import { DICTIONARY } from '../translations/dictionary';

class FilesServices {
  static downloadPdf = (data) => {
    if (data?.size < 500) {
      store.set(openInfoModalAtom, {
        text: tStatic(DICTIONARY.error),
      });
      return { isError: true };
    }
    const blob = new Blob([data], { type: 'application/pdf' });
    saveAs(blob, 'aig-configurator.pdf');
    return { isError: false };
  };

  static downloadDocx = (data) => {
    if (data?.size < 500) {
      store.set(openInfoModalAtom, {
        text: tStatic(DICTIONARY.error),
      });
      return { isError: true };
    }

    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    saveAs(blob, 'aig-configurator.docx');
    return { isError: false };
  };
}

export default FilesServices;
*/

import { saveAs } from 'file-saver';
import store from '../atoms';
import { openInfoModalAtom } from '../atoms/modalAtoms';
import tStatic from '../translations';
import { DICTIONARY } from '../translations/dictionary';

/* function downloadFile(blob, filename) {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    // Safari: Try object URL in <a>, fallback to opening PDF in a new tab
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  } else {
    saveAs(blob, filename);
  }
} */

function downloadFile(blob, filename) {
  // IE 11 (just in case)
  const navAny = window.navigator;
  if (navAny && typeof navAny.msSaveOrOpenBlob === 'function') {
    navAny.msSaveOrOpenBlob(blob, filename);
    return;
  }

  const ua = navigator.userAgent;
  const isIOS = /iP(ad|hone|od)/.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua) && !/chrome|crios|fxios/i.test(ua);

  // iOS Safari: download attribute is unreliable. Best is server-side attachment.
  if (isIOS) {
    // Fallback: open as data URL (OK for small files; prefer server Content-Disposition for real downloads)
    const reader = new FileReader();
    reader.onloadend = () => {
      const a = document.createElement('a');
      a.href = reader.result;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      // no revoke for data URLs
    };
    reader.readAsDataURL(blob);
    return;
  }

  const blobUrl = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  a.rel = 'noopener';
  if (isSafari) a.target = '_blank'; // helps on macOS Safari

  document.body.appendChild(a);
  a.click();
  a.remove();

  // IMPORTANT: don't revoke immediately — Safari fetches lazily.
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
}

class FilesServices {
  static downloadPdf = (blob, headers) => {
    if (!blob || blob.length < 500) {
      store.set(openInfoModalAtom, {
        text: tStatic(DICTIONARY.error),
      });
      return { isError: true };
    }

    const filename = this.getFileName(headers, 'pdf');
    downloadFile(blob, filename);
    return { isError: false };
  };

  static downloadDocx = (blob, headers) => {
    if (!blob || blob.length < 500) {
      store.set(openInfoModalAtom, {
        text: tStatic(DICTIONARY.error),
      });
      return { isError: true };
    }

    const filename = this.getFileName(headers, 'docx');

    // const blob = base64ToBlob(base64Data, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
    downloadFile(blob, filename);
    return { isError: false };
  };

  static getFileName = (headers, extension) => {
    const contentDisposition = headers['content-disposition'];
    let filename = `aig-configurator.${extension}`;
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch && fileNameMatch[1]) {
        [, filename] = fileNameMatch;
      }
    }

    return filename;
  };
}

export default FilesServices;
